import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {GenericService} from "projects/nter-ui-kit/src/lib/framework/common/generic.service";
import {
  GrantedModuleRole,
  GrantForConsoleRequest,
  RBACModule,
  RBACRole,
  RevokeGrant
} from "projects/nter-ui-kit/src/lib/framework/security/model/user-access.model";
import {AppConfigService} from "projects/nter-ui-kit/src/lib/framework/config/app-config.service";

@Injectable({
  providedIn: 'root'
})
export class UserAccessService extends GenericService<GrantedModuleRole> {

  constructor(http: HttpClient, private _config: AppConfigService) {
    super(http, _config.environment.apiSecurityHost + `/console/rbac/offering`);
  }

  getAllRoles(): Observable<RBACRole[]> {
    return this.http.get<RBACRole[]>(this.baseUrl + '/roles');
  }

  getAllModules(): Observable<RBACModule[]> {
    return this.http.get<RBACModule[]>(this.baseUrl + '/modules');
  }

  //todo move to authorization service
  saveAccessRequest(request: GrantForConsoleRequest): Observable<void> {
    return this.http.post<void>(this._config.environment.apiSecurityHost + '/console/rbac/user/grant', request);
  }

  revokeAccess(request: RevokeGrant[]): Observable<void> {
    return this.http.post<void>(this._config.environment.apiSecurityHost + '/console/rbac/user/revoke', request);
  }

  reconcileGrants(userId: number): Observable<void> {
    return this.http.post<void>(this._config.environment.apiSecurityHost + `/${userId}/duplicate-grants/reconcile`, null);
  }
}
